import React from 'react';
import { Box, Typography, List, ListItem, ListItemAvatar, Avatar, ListItemText } from '@mui/material';

interface TopTracksProps {
  tracks: any[];
  features: any[];
}

const TopTracks: React.FC<TopTracksProps> = ({ tracks, features }) => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom textAlign="center">
        Your Top {tracks.length} Tracks
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 2 }}>
        {features.length > 0 ? `${features.length} tracks with audio features` : 'Audio features not available'}
      </Typography>
      <List>
        {tracks.map((track, index) => {
          const audioFeature = features[index];
          const hasFeatures = audioFeature && typeof audioFeature.valence !== 'undefined';
          
          return (
            <ListItem key={track.id || index}>
              <ListItemAvatar>
                <Avatar src={track.album?.images?.[0]?.url} alt={track.name} />
              </ListItemAvatar>
              <ListItemText
                primary={
                  hasFeatures 
                    ? `${track.name} (Valence: ${audioFeature.valence.toFixed(2)}, Energy: ${audioFeature.energy.toFixed(2)})`
                    : track.name
                }
                secondary={track.artists?.map((artist: any) => artist.name).join(', ') || 'Unknown Artist'}
              />
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default TopTracks;
